'use strict';

function MortgageConsent() {
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController, _FormWizard];

  this._bankruptcyFormStateEdit = false;
  this._legalFormStateEdit = false;
  this._bankruptcyFormSubmittedData = false;
  this._legalFormSubmittedData = false;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    if (this.checkMortgageApplicationEligibility()) {
      this._$bankruptcyWizardSection = this.$node.find('.form-wizard__section').eq(0);
      this._$legalWizardSection = this.$node.find('.form-wizard__section').eq(1);

      this._$bankruptcyForm = this._$bankruptcyWizardSection.find('form');
      this._$legalForm = this._$legalWizardSection.find('form');

      this._$bankruptcyCancel = $('.js-cancel-bankruptcy');
      this._$bankruptcyContinue = $('.js-bankruptcy-continue');
      this._$legalContinue = $('.js-legal-continue');

      if (!this._bankruptcyFormSubmittedData) {
        this._bankruptcyFormStateEdit = true;
      }

      this._setupActions();
      this._setupWizardState();
      this._setupEvents();
      this._setupComputedVariables();
      this._updateWizardState();

      this.presenter.scanDOM();

      this.analytics.pushEvent('virtual-page-view');
      this.pushAnalyticsMortgageChoices();
    }
  };

  this.destroy = function () {
    this._super();

    // remove actions
    this.presenter.removeCallbackFromAction('mortgage.update_mortgage_application', this._actionIdUpdate);
    this.presenter.removeCallbackFromAction('mortgage.submit_mortgage_application', this._actionIdSubmit);

    // remove computed variables
    this.presenter.removeComputedVariable('bankruptcy_has_submitted_data');
    this.presenter.removeComputedVariable('show_submit_button');

    this.presenter.resetModels('mortgage');
    // Only update mortgage_applications when the user leaves the page.
    // update on save is unneeded as the user is redirected away
    this.presenter.updateModel('mortgage_applications');
  };

  this._setupComputedVariables = function () {
    var _this = this;

    this.presenter.addComputedVariable('bankruptcy_has_submitted_data', ['mortgage.was_bankrupt'], function () {
      return _this._bankruptcyFormSubmittedData;
    });

    this.presenter.addComputedVariable('show_submit_button', ['mortgage.credit_check_consent'], function (creditCheck) {
      _this._updateButtonState();
      return creditCheck && _this._bankruptcyFormSubmittedData && _this._getState(_this._$legalWizardSection) == _this.states.summary && _this._getState(_this._$bankruptcyWizardSection) == _this.states.summary;
    });
  };

  this._setupEvents = function () {
    var _this2 = this;

    this._$bankruptcyCancel.on('click.MortgageConsent', function (e) {
      e.preventDefault();
      _this2.presenter.resetModels('mortgage');

      if (_this2.presenter.getModelProperty('mortgage.credit_check_consent')) {
        _this2._bankruptcyFormStateEdit = false;
        _this2._legalFormStateEdit = false;
      } else {
        _this2._bankruptcyFormStateEdit = false;
        _this2._legalFormStateEdit = true;
      }

      _this2._updateWizardState();
    });

    this._$legalContinue.on('click.MortgageConsent', function (e) {
      if (_this2.presenter.getModelProperty('mortgage.credit_check_consent')) {
        _this2.analytics.forcePushEvent('form-submit', {
          FormID: ['MogoMortgage-Form submission-Consent-null-Form']
        });
        $('.js-credit-check-boolean').mogo().hideError();
        _this2._changeState(_this2._$legalWizardSection, _this2.states.summary);
        _this2.presenter.updateDOM();
      } else {
        $('.js-credit-check-boolean').mogo().showErrorLabel();
      }
    });
  };

  this._setupActions = function () {
    var _this3 = this;

    this._bankruptcyFormSubmittedData = this.presenter.models.mortgage.isPersistent() && typeof this.presenter.getModelProperty('mortgage.was_bankrupt') === 'boolean';
    this._legalFormDataIsSet = typeof this.presenter.getModelProperty('mortgage.credit_check_consent') === 'boolean';

    this._actionIdSubmit = this.presenter.addCallbackToAction('mortgage.submit_mortgage_application', function (data, response) {
      if (response === 200) {
        _this3.presenter.updateModel('mortgage', data);

        // analytics
        _this3.analytics.forcePushEvent('form-submit', {
          FormID: ['MogoMortgage-Form submission-Consent summary-null-Form']
        });
        var analyticsData = _this3.analytics.constructData('Mortgage Application Submitted');
        var analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);
        analyticsRequest.send();

        _this3._moveToFinalPage();
      } else {
        // if (data.errors) this.$formApplicant.mogo().parseErrorObject(data.errors); //TODO add this back when kisnon adds it back
        $('#Notification').mogo().get();
      }
    });

    this._actionIdUpdate = this.presenter.addCallbackToAction('mortgage.update_mortgage_application', function (data, response) {
      if (response === 200) {
        // update model and states
        _this3.analytics.forcePushEvent('form-submit', {
          FormID: ['MogoMortgage-Form submission-Bankruptcy-null-Form']
        });
        _this3.presenter.updateModel('mortgage', data);
        _this3._bankruptcyFormStateEdit = false;
        _this3._legalFormStateEdit = true;

        _this3._updateWizardState();
        _this3.presenter.updateDOM();

        setTimeout(function () {
          _this3._bankruptcyFormSubmittedData = true;
          _this3._updateWizardState();
          _this3.presenter.updateDOM();
        }, 700);
      } else {
        console.warn('Submission Error, failed to update Wizard state');
      }
    });
  };

  this._setupWizardState = function () {
    var _this4 = this;

    if (this._bankruptcyFormSubmittedData) {
      this._bankruptcyFormStateEdit = false;
      this._legalFormStateEdit = true;
    }

    this._$bankruptcyWizardSection.find('.icon--edit').on('click.editWizardForm', function () {
      _this4._bankruptcyFormStateEdit = true;
      _this4._legalFormStateEdit = false;
      _this4._updateWizardState();
      _this4.presenter.updateDOM();
    });

    this._$legalWizardSection.find('.icon--edit').on('click.editWizardForm', function () {
      _this4._bankruptcyFormStateEdit = false;
      _this4._legalFormStateEdit = true;
      _this4._updateWizardState();
      _this4.presenter.updateDOM();
    });
  };

  this._updateWizardState = function () {
    if (this._bankruptcyFormStateEdit) {
      if (this._getState(this._$bankruptcyWizardSection) !== this.states.edit) {
        this._changeState(this._$bankruptcyWizardSection, this.states.edit);
      }
      if (this.presenter.getModelProperty('mortgage.credit_check_consent')) {
        this._changeState(this._$legalWizardSection, this.states.summary);
      } else {
        this._changeState(this._$legalWizardSection, this.states.passive);
      }
    } else {
      this._changeState(this._$bankruptcyWizardSection, this.states.summary);
    }

    if (this._legalFormStateEdit) {
      if (this._getState(this._$legalWizardSection) !== this.states.edit) {
        this._changeState(this._$legalWizardSection, this.states.edit);
      }

      this._changeState(this._$bankruptcyWizardSection, this.states.summary);
    }
  };

  this._updateButtonState = function () {
    if (this.presenter.getModelProperty('mortgage.credit_check_consent')) {
      this._$legalContinue.attr('data-analytics-id', 'MogoMortgage-Consent-Form attempt-null-SubmitClick');
    } else {
      this._$legalContinue.attr('data-analytics-id', 'MogoMortgage-Consent-Form attempt Disabled-null-SubmitClick');
    }
  };

  this._moveToFinalPage = function () {
    var tray = this._tray();
    tray._navigation.setCompleted(tray._navigation.getSelectedIndex());
    tray._navigation.setSelectedIndex(-1);
    tray.disableAllSteps();
    this._history.goToUrl('/member/dashboard/mortgage/new/submitted', null, null);
  };
}